import React from "react";
import { useState, useEffect } from "react";
import Pagination from "../../components/Pagination/Pagination";
import AxiosService from "../../utils/AxiosService";
import { toast } from "react-toastify";
import AuthServiceStroage from "../../utils/auth_service/AuthServiceStorage";
import PaginationInfo from "../../components/PaginationInfo/PaginationInfo";
import UpdateManuscriptStatus from "./UpdateManuscriptStatus";
import LocalStorageService from "../../utils/auth_service/AuthServiceStorage";


const AssignedUserHeader = [
  "CURATOR NAME",
  "ASSIGNED COUNT",
  "PENDING COUNT",
  // "THRESHOLD",
  "DESCRIPTION",
  "CURATOR DUE DATE",
  "ACTION",
];

  const initialFormData = {
    curator: "",
    dueDate: "",
    threshold: "",
    allocatedBy: "count",
    noOfRows: "",
    description: "",
  };  

const AssignUserPage = () => {
  const apiService = new AxiosService();
  const authDetails = AuthServiceStroage.getAuthDetails();
  const [totalPaginationCount, setTotalPaginationCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [project, setProject] = useState("");
  const [projects, setProjects] = useState([]);
  const [curators, setCurators] = useState([]);
  const [thresholds, setThresholds] = useState([]);
  const [showReassignModal, setShowReassignModal] = useState(false);
  const [formData, setFormData] = useState(initialFormData);
  const [totalManuscriptCount, setTotalManuscriptCount] = useState(0);
  const [availableManuscriptCount, setAvailableManuscriptCount] = useState(0);
  const [assignedUsers, setAssignedUsers] = useState([]);
  const [assignedTotalCount, setAssignedTotalCount] = useState(0);
  const [reassignId, setReassignId] = useState(0);
  const [pendingCount, setPendingCount] = useState(0);
  const [projectStatusReport, setprojectStatusReport] = useState([]);
  const [curatorDropdownOptions, setCuratorDropdownOptions] = useState([]);
    const [projectReport, setprojectReport] = useState([]);
    const [maxRange, setmaxRange] = useState()
       const [minRange, setminRange] = useState("")
    const [userName,setUserName]=useState("");

  const localStorageService = LocalStorageService.getService();

  const [reassignFormData, setReassignFormData] = useState({
    reassignCurator: "",
    reassignDueDate: "",
    manuscriptCount: 0,
    reassignToAssigned:0,
  });



  useEffect(() => {
    if (project !== "") {
      apiService
        .getDistinctThresholdByProject(project)
        .then((response) => {
          console.log(response.data);
          setThresholds(response.data.data);
        })
        .catch((error) => {
          toast.error(error.response.data.message, { autoClose: 3000 });
        });

      apiService
        .getAssignedUserDetailsCount(project)
        .then((response) => {
          console.log(response.data);
          setAssignedTotalCount(response.data.data);
          onPageChange(currentPage);
        })
        .catch((error) => {
          setAssignedUsers([]);
          toast.error(error.response.data.message, { autoClose: 3000 });
        });
      apiService
        .getPendingCountByProjectAndThreshold(project, "1")
        .then((response) => {
          console.log(response.data);
          setAvailableManuscriptCount(response.data.data);
        })
        .catch((error) => {
          toast.error(error.response.data.message, { autoClose: 3000 });
        });
      apiService
        .getProjectStatusReport(project)
        .then((response) => {
          setprojectStatusReport(response.data.data);
        })
        .catch((error) => {
          toast.error(error.response.data.message, { autoClose: 3000 });
        });
    }
  }, [project]);

  useEffect(() => {
    apiService
      .getCuratorList("Curator")
      .then((response) => {
        console.log(response.data);
        setCurators(response.data.data.result);
      })
      .catch((error) => {
        toast.error(error.response.data.message, { autoClose: 3000 });
      });
  }, []);

//   useEffect(() => {
//     setprojectReport(projectStatusReport);
//   }, [projectStatusReport]);

  useEffect(() => {
    apiService
      .getProjectList()
      .then((response) => {
        console.log(response.data);
        setProjects(response.data.data);
      })
      .catch((error) => {
        toast.error(error.response.data.message, { autoClose: 3000 });
      });
  }, []);

  const handleProjectChange = (event) => {
    const projectId = event.target.value;
    setProject(projectId);
    const selectedProject = projects.find((project) => {
      if (project.projectId == projectId) {
        return project;
      }
    });
    localStorageService.setProjectDetails(
      JSON.stringify({
        projectId: projectId,
        projectName: selectedProject ? selectedProject.projectName : "",
      })
    );
  };

  const handleRowChange = (event) => {
    const { name, value } = event.target;
    let newValue = Number(value);

    if (newValue > availableManuscriptCount || newValue < 0) {
      toast.warn("Number of ID's must be less than or equal to available count",{autoClose:2000})
      newValue = "";
    }

    setFormData((prev) => ({
      ...prev,
      [name]: newValue,
    }));
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const onPageChange = (pagNumber) => {
    if (project !== "") {
      apiService
        .getAssignedUserDetails(project, pagNumber)
        .then((response) => {
          setAssignedUsers(response.data.data);
          setCurrentPage(pagNumber);
        })
        .catch((error) => {
          toast.error(error.response.data.message, { autoClose: 3000 });
        });
        apiService
          .getAssignedUserDetailsCount(project)
          .then((response) => {
            setAssignedTotalCount(response.data.data);
          })
          .catch((error) => {
            setAssignedUsers([]);
            toast.error(error.response.data.message, { autoClose: 3000 });
          });
    }
  };
  
  const onAssignHandler = () => {
    if (formData) {
      // Collect empty fields
      let emptyFields = [];

      if (!formData.curator) emptyFields.push("Curator");
      if (!formData.dueDate) emptyFields.push("Due Date");
      // if (!formData.threshold || formData.threshold === 0)
      //   emptyFields.push("Threshold");
      if (!formData.noOfRows || formData.noOfRows === 0)
        emptyFields.push("Number of manuscript Id's");
      if (!formData.description) emptyFields.push("Description");

      const today = new Date();
      today.setHours(0, 0, 0, 0); 
      const selectedDueDate = new Date(formData.dueDate);

      if (formData.dueDate && selectedDueDate < today) {
        toast.error("Due Date cannot be earlier than today");
        return;
      }

      if (emptyFields.length === 0) {
        const params = {
          projectId: project,
          curatorName: formData.curator,
          threshold: formData.threshold,
          dueDate: formData.dueDate,
          count: formData.noOfRows,
          description: formData.description,
        };
        apiService
          .assign(params)
          .then((response) => {
            console.log(response.data);
            toast.success(response.data.message);
            resetForm();
            onPageChange(currentPage);
            apiService
              .getPendingCountByProjectAndThreshold(project, "1")
              .then((response) => {
                console.log(response.data);
                setAvailableManuscriptCount(response.data.data);
              })
              .catch((error) => {
                toast.error(error.response.data.message, { autoClose: 3000 });
              });
          })
          .catch((error) => {
            toast.error(error.response.data.message, { autoClose: 3000 });
          });
      } else {
        toast.warn(
          `Please fill in the following fields: ${emptyFields.join(", ")}`
        );
      }
    }
  };

  const resetForm = () => {
    setFormData(initialFormData);
    setTotalManuscriptCount(0);
    setAvailableManuscriptCount(0);
  };

  const onSubmitModal = () => {
    if (reassignFormData) {
      if (
        reassignFormData.manuscriptCount > pendingCount ||
        reassignFormData.manuscriptCount < 0
      ) {
        toast.warn(
          "Manuscript count must be greater than zero and less than Available Manuscripts"
        );
      } else {
        // Collect empty fields
        let emptyFields = [];

        if (!reassignFormData.reassignCurator) emptyFields.push("Curator");
        if (!reassignFormData.reassignDueDate) emptyFields.push("Due Date");
        if (reassignFormData.manuscriptCount == 0)
          emptyFields.push("Number of Manuscripts");

        if (emptyFields.length === 0) {
          const confirmReassign = window.confirm(
            "Are you sure to reassign selected data?"
          );
          if (confirmReassign) {
            
            apiService
              .reAssign(
                reassignFormData.reassignCurator,
                reassignFormData.reassignDueDate,
                reassignFormData.manuscriptCount,
                reassignId,
                reassignFormData.reassignToAssigned,
              )
              .then((response) => {
                console.log(response.data.message);
                setShowReassignModal(false);
                toast.success(response.data.message);
                onPageChange(currentPage);
                setReassignFormData({});
              })
              .catch((error) => {
                toast.error(error.response.data.message, { autoClose: 3000 });
                setReassignFormData({});
              });
          }
        } else {
          toast.warn(
            `Please fill in the following fields: ${emptyFields.join(", ")}`
          );
        }
      }
    }
  };

    const onModalClose = () => {
      setShowReassignModal(false);
      setReassignFormData({});
    };

    function handleReassignChange(event) {
      const { name, value } = event.target;
      let newValue = value;

      if (name === "reassignToAssigned" && value === "") {
        newValue = 0;
      }

      if (name === "reassignCurator" && value !== "") {
        if (project && value) {
          apiService
            .getCuratorDataForProject(parseInt(project), value)
            .then((response) => {
              const options = response.data?.data || [];
              setCuratorDropdownOptions(options);
            })
            .catch((error) => {
              toast.error("Failed to load curator options", {
                autoClose: 3000,
              });
              setCuratorDropdownOptions([]);
            });
        }

        setReassignFormData((prevData) => ({
          ...prevData,
          reassignToAssigned: 0,
        }));
      }

      setReassignFormData((prevData) => {
        const updated = { ...prevData, [name]: newValue };
        console.log("Updated Form Data:", updated);
        return updated;
      });
    }
    

  const onModalOpen = (assignedId, pendingCount,userName) => {
    setReassignId(assignedId);
    setPendingCount(pendingCount);
    setShowReassignModal(true);
    setUserName(userName);
    // if (project && userName) {
    // apiService
      // .getCuratorDataForProject(parseInt(project), userName)
      // .then((response) => {
        // console.log('responseDropDown:',response);
        // setCuratorDropdownOptions(response.data.data); 
      // })
      // .catch((error) => {
        // toast.error("Failed to load curator options", { autoClose: 3000 });
        // setCuratorDropdownOptions([]);
      // });
  // }
  };

useEffect(() => {
    if (project !== "") {
      apiService
        .getTotalCountByProjectAndThreshold(project, "1")
        .then((response) => {
          console.log(response.data);
          setTotalManuscriptCount(response.data.data);
        })
        .catch((error) => {
          toast.error(error.response.data.message, { autoClose: 3000 });
        });

      apiService
        .getPendingCountByProjectAndThreshold(project, "1")
        .then((response) => {
          console.log(response.data);
          setAvailableManuscriptCount(response.data.data);
        })
        .catch((error) => {
          toast.error(error.response.data.message, { autoClose: 3000 });
        });
    }
  }, [formData, project]);

  return (
    <div className="container-fluid">
      <h3 className="text-center">Assign User</h3>
      <label htmlFor="project" className="form-label">
        Project
      </label>
      <select
        className="form-select form-select-sm"
        id="project"
        name="project"
        style={{ width: "300px" }}
        onChange={handleProjectChange}
      >
        <option selected value={""}>
          Choose Project..
        </option>

        {projects &&
          projects.map((project) => (
            <option
              value={project.projectId}
              className="bg-gray-100 hover:bg-gray-200"
              key={project.projectId}
            >
              {project.projectName}
            </option>
          ))}
      </select>
      <div className="pt-3 ">
        {project !== "" && (
          <div className="card">
            <div className="card-body">
              <h4>Assign User</h4>
              <form className="row g-3">
                <div className="col-md-6">
                  <label htmlFor="curator" className="form-label">
                    Curator
                  </label>
                  <select
                    id="curator"
                    className="form-select"
                    value={formData.curator}
                    name="curator"
                    onChange={handleChange}
                  >
                    <option selected>Choose Curator..</option>
                    {curators.map((curator, index) => (
                      <option key={curator.userName} value={curator.userName}>
                        {curator.userName}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-md-6">
                  <label htmlFor="dueDate" className="form-label">
                    Due Date (curator)
                  </label>
                  <input
                    type="date"
                    className="form-control"
                    id="dueDate"
                    name="dueDate"
                    value={formData.dueDate}
                    onChange={handleChange}
                  />
                </div>
                {/* <div className="col-md-6">
                  <label htmlFor="threshold" className="form-label">
                    Select Threshold
                  </label>
                  <select
                    id="threshold"
                    className="form-select"
                    value={formData.threshold}
                    name="threshold"
                    onChange={handleChange}
                  >
                    <option selected>Choose Threshold...</option>
                    {thresholds.map((threshold, index) => (
                      <option key={threshold} value={threshold}>
                        {threshold}
                      </option>
                    ))}
                  </select>
                </div> */}
                <div className="col-md-6">
                  <label htmlFor="allocatedby" className="form-label">
                    Allocated By
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="allocatedBy"
                    name="allocatedBy"
                    value={formData.allocatedBy}
                    disabled
                  />
                </div>

                <div className="col-md-6">
                  <label htmlFor="noOfRows" className="form-label">
                    Number of manuscript Id's
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    id="noOfRows"
                    name="noOfRows"
                    value={formData.noOfRows}
                    onChange={handleRowChange}
                    max={availableManuscriptCount}
                    min={0}
                  />
                  <div className="col-md-6">
                    <div className="d-flex align-items-start pt-1">
                      <div>
                        Available{" "}
                        <span className="badge bg-success">
                          {availableManuscriptCount}
                        </span>
                      </div>
                      <div className="ms-2">
                        / Total{" "}
                        <span className="badge bg-primary">
                          {totalManuscriptCount}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-12">
                  <label htmlFor="description" className="form-label">
                    Batch Name
                  </label>
                  <textarea
                    className="form-control"
                    id="description"
                    rows="3"
                    value={formData.description}
                    name="description"
                    onChange={handleChange}
                  ></textarea>
                </div>
                <div className="d-grid gap-2 d-md-flex justify-content-md-end">
                  <button
                    className="btn btn-outline-secondary me-md-2"
                    type="button"
                    onClick={resetForm}
                  >
                    Reset
                  </button>
                  <button
                    className="btn btn-primary"
                    type="button"
                    onClick={onAssignHandler}
                  >
                    Assign
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}
        {assignedUsers.length !== 0 && (
          <div className="border rounded mb-4 mt-2">
            <div className="pt-2 ms-2">
              <h4>Assigned Users</h4>
            </div>
            <div className="d-flex justify-content-between align-items-center  p-3">
              <PaginationInfo
                dataName={"Showing "}
                totalItems={assignedTotalCount}
                currentPage={currentPage}
              />
            </div>
            <table className="table table-hover mb-0">
              <thead className="">
                <tr className="bg-primary">
                  {AssignedUserHeader.map((item, index) => (
                    <th
                      className="col bg-light text-nowrap text-secondary fs-6 fw-medium"
                      key={item}
                    >
                      {item}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {assignedUsers.map((user, index) => (
                  <tr key={user.assignedId}>
                    <td className="align-middle">{user.curator}</td>
                    <td className="align-middle">{user.assignedCount}</td>
                    <td className="align-middle">
                      {user.assignedCount - user.pendingCount}
                    </td>
                    {/* <td className="align-middle">{user.threshold}</td> */}
                    <td className="align-middle">{user.description}</td>
                    <td className="align-middle">{user.dueDate}</td>
                    <td className="align-middle">
                      {" "}
                      <button
                        className="btn btn-outline-primary me-md-2"
                        type="button"
                        onClick={() =>
                          onModalOpen(
                            user.assignedId,
                            user.assignedCount - user.completedCount,
                            user.curator
                          )
                        }
                      >
                        Reassign
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div className="m-3 mb-0">
              <Pagination
                totalCount={assignedTotalCount}
                currentPage={currentPage}
                onPageChange={onPageChange}
              />
            </div>
          </div>
        )}
      </div>

      {showReassignModal && (
        <div className="modal fade show d-block" tabIndex="-1">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header border-0">
                <div>
                  <h5 className="modal-title" id="exampleModalLabel">
                    Reassign Curator
                  </h5>
                  <small className="text-muted">
                    Please select the other user and due date to assign a new
                    curator.
                  </small>
                </div>
                <button
                  type="button"
                  className="btn-close"
                  onClick={onModalClose}
                  aria-label="Close"
                ></button>
              </div>

              <div className="modal-body border-0">
                <div className="mb-3">
                  <label htmlFor="curator" className="form-label">
                    Curator
                  </label>
                  <select
                    id="curator"
                    className="form-select"
                    name="reassignCurator"
                    value={reassignFormData.reassignCurator}
                    onChange={handleReassignChange}
                  >
                    <option value="">Choose Curator...</option>
                    {curators.map(
                      (curator) =>
                        userName !== curator.userName && (
                          <option
                            key={curator.userName}
                            value={curator.userName}
                          >
                            {curator.userName}
                          </option>
                        )
                    )}
                  </select>
                </div>
                <div className="mb-3">
                  <label htmlFor="dueDate" className="form-label">
                    Due Date (curator)
                  </label>
                  <input
                    type="date"
                    className="form-control"
                    id="dueDate"
                    name="reassignDueDate"
                    value={reassignFormData.reassignDueDate}
                    onChange={handleReassignChange}
                  />
                </div>
                <div className="mb-3">
                  <label htmlFor="manuscriptCount" className="form-label">
                    Number of Manuscripts
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    id="manuscriptCount"
                    name="manuscriptCount"
                    min={0}
                    value={reassignFormData.manuscriptCount}
                    onChange={handleReassignChange}
                  />
                </div>
                <div className="mb-3">
                  <label htmlFor="reassignToAssigned" className="form-label">
                    Destination batch
                  </label>
                  <select
                    id="reassignToAssigned"
                    className="form-select"
                    name="reassignToAssigned"
                    value={reassignFormData.reassignToAssigned || 0}
                    onChange={handleReassignChange}
                  >
                    <option value={0}>Choose Option...</option>
                    {curatorDropdownOptions
                      .filter((option) => option.assignedId !== reassignId)
                      .map((option) => (
                        <option
                          key={option.assignedId}
                          value={option.assignedId}
                        >
                          {option.description}
                        </option>
                      ))}
                  </select>
                </div>

                <div>
                  Available Manuscripts{" "}
                  <span className="badge bg-success">{pendingCount}</span>
                </div>
              </div>
              <div className="modal-footer border-0">
                <button
                  type="button"
                  className="btn btn-outline-secondary"
                  onClick={onModalClose}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={onSubmitModal}
                >
                  Confirm
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
export default AssignUserPage;
